export default function (state) {
    let data = {};
    data.DateFrom = state.dates[0];
    data.DateTo = state.dates[1];
    if(state.AccountId) data.AccountId = state.AccountId;
    if(state.SubAccountId) data.SubAccountId = state.SubAccountId;
    if(state.ContragentId) data.PartnerId = state.ContragentId;
    if(state.CurrencyId) data.CurrencyId = state.CurrencyId;
    if(state.PaymentAccountId) data.PaymentAccountId = state.PaymentAccountId;
    data.WithTurns = state.WithTurns;
    data.WithDocumens = state.WithDocumens;
    return data;
}
